import { ComponentRef, Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { RxBusyComponent } from './rx-busy/rx-busy.component';

@Directive({
  selector: '[rxBusy]',
})
export class RxBusyDirective {
  public spinnerComponent: ComponentRef<RxBusyComponent>;

  @Input()
  public set rxBusy(loading: boolean) {
    if (loading) {
      this.spinnerComponent = this.vcRef.createComponent(RxBusyComponent);
    } else {
      this.vcRef.createEmbeddedView(this.templateRef);
    }
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private vcRef: ViewContainerRef,
  ) {}
}
